import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-success',
  templateUrl: './icon-success.component.html',
  styleUrls: ['./icon-success.component.scss']
})
export class IconSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
